module.exports = __webpack_public_path__ + "img/1.16a5fba5.png";